import { legacyPlugins } from "/home/runner/work/qx-lunarheart/qx-lunarheart/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}